import React from 'react'
import styles from './styles.module.scss'

function Tag({ text, color, className, position = 'left' }) {
  return <div className={`${styles.tag} ${styles[color]} ${styles[position]} ${className}`}>{text}</div>
}

export default Tag
